import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmergencyRequestCenterComponent} from "./emergency-request-center.component";

const routes: Routes = [
    {
        path: '',
        component: EmergencyRequestCenterComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class EmergencyRequestCenterRoutingModule {}
